
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import UnitInput from "@/components/Reusable/CustomInputs/UnitInput/UnitInput.vue";
import { RangeOptions } from "@/types/controls";
import { ControlUnit } from "@/oxygen/classes/lib/types";
import { UnitInputValue, UnitOptions } from "@/types/unit";

@Component({
  components: { UnitInput }
})
export default class OxygenUnitInput extends Vue {
  @Prop()
  control!: ControlUnit;

  @ModelSync("value", "input")
  syncedValue?: UnitInputValue;

  @Prop()
  placeholder?: UnitInputValue;

  get options(): UnitOptions {
    return {
      defaultType: this.control.defaultType,
      types: this.control.types
    };
  }

  get rangeOptions(): RangeOptions {
    return {
      min: this.control.min,
      max: this.control.max,
      step: this.control.step
    };
  }
}
